import { render, staticRenderFns } from "./Categorise.vue?vue&type=template&id=a79030ec&scoped=true"
import script from "./Categorise.vue?vue&type=script&lang=ts"
export * from "./Categorise.vue?vue&type=script&lang=ts"
import style0 from "./Categorise.vue?vue&type=style&index=0&id=a79030ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79030ec",
  null
  
)

export default component.exports